// extracted by mini-css-extract-plugin
module.exports = {"container":"Braintree_container__391tC"};